export const speakers = [
  {
    id: 'bcd0aaf4-ef85-4317-91e2-64f9b724c2ba',
    company: 'Anaqor @ StoneOne AG',
    country: 'Germany',
    featured: true,
    isConfirmed: true,
    longDesc:
      'Michael is the chief architect of the quantum platform being developed as part of the lighthouse project PlanQK - Platform and Ecosystem for Quantum Applications - which is funded by the German Federal Ministry for Economic Affairs and Climate Action. Through his scientific work at the Institute for Architecture of Application Systems at the University of Stuttgart, he is one of the driving forces behind PlanQK. He is currently in the process of establishing Anaqor - the new business unit of StoneOne AG - to sustain the German Quantum Ecosystem built by PlanQK. ',
    name: 'Michael Falkenthal',
    photo:
      'https://www.openslava.sk/images/2022/michael_falkenthal_bcd0aaf4-ef85-4317-91e2-64f9b724c2ba.jpg',
    shortDesc: 'Michael is the chief archit...',
    order: 0,
    talks: ['3e3a5ac1-057e-447b-88e5-1ff59cd02041']
  },
  {
    id: '8a8535e4-115e-426b-a558-6f84fdd5d258',
    company: 'Všeobecná úverová banka',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Big Data Developer. I have been working with data and advance analytics tools for several years. Recently I have been focusing on machine learning and its application in banking',
    name: 'Anton Kovaľ  ',
    photo:
      'https://www.openslava.sk/images/2022/anton_kovaľ  _8a8535e4-115e-426b-a558-6f84fdd5d258.jpg',
    shortDesc: 'Big Data Developer. I have ...',
    order: 0,
    talks: ['70f69c68-8d02-4399-8a15-35b74dc4a4a7']
  },
  {
    id: 'ab677149-6c97-491d-aed7-d0202114c9d9',
    company: 'Adverity',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc:
      'I have been working with data for 10 years, leading data teams for 8 and focused specifically on marketing and augmented analytics for 5. I am a data geek at heart, but I have over the course of my career realized that the hardest part of making Data Science teams productive is not building a fancy model, but turning it into something business users can meaningfully consume. That is what I focus on.',
    name: 'Roman Gavuliak',
    photo:
      'https://www.openslava.sk/images/2022/roman_gavuliak_ab677149-6c97-491d-aed7-d0202114c9d9.jpg',
    shortDesc: 'I have been working with da...',
    order: 0,
    talks: ['cf6a1ddb-bf5b-46ec-a2b5-c08a7803491e']
  },
  {
    id: '62d62112-a4ce-4ceb-ad23-24beee12bae8',
    company: 'VÚB a.s.',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc:
      'IT architect with more than 20 years experience in various IT positions.  Started as administrator, and through consultances moved to the area of architecture. I really enjoy to troubleshoot complex problems. My specialities are digital identity, IT and Network security.',
    name: 'Peter Procházka',
    photo:
      'https://www.openslava.sk/images/2022/peter_procházka_62d62112-a4ce-4ceb-ad23-24beee12bae8.jpg',
    shortDesc: 'IT architect with more than...',
    order: 0,
    talks: ['2e80a664-3082-4ee6-8bc4-ffcc91ec0383']
  },
  {
    id: '5893c0b1-c46c-44fd-8d63-806a37c271fb',
    company: 'Siemens Healthineers',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc:
      "Matej currently serves as Release Train Engineer, Scrum Master and Software Developer in Siemens Healthineers on Common Host Platform project, which uses modern approaches and technologies, like Scrum/Kanban, .NET Core, Azure DevOps... He joined Siemens almost 10 years ago during his studies of Informatics on FEI TUKE. Matej's biggest passion is to solve challenges and best way to get him to do something is to tell him that it cannot be done :)",
    name: 'Matej Adamcik',
    photo:
      'https://www.openslava.sk/images/2022/matej_adamcik_5893c0b1-c46c-44fd-8d63-806a37c271fb.jpg',
    shortDesc: 'Matej currently serves as R...',
    order: 0,
    talks: ['937b1dd7-2415-43b1-8d27-747e1c88c4d1']
  },
  {
    id: '041a24c7-a827-4c5e-84f3-d4744ab68f40',
    company: 'Accenture Austria',
    country: 'Austria',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Martin works in the Enterprise Architecture domain at Accenture. Over the last years, he used his Full-Stack and Cloud Native skills in various projects mainly in JavaScript/Typescript domain. ',
    name: 'Martin Mayr',
    photo:
      'https://www.openslava.sk/images/2022/martin_mayr_041a24c7-a827-4c5e-84f3-d4744ab68f40.jpg',
    shortDesc: 'Martin works in the Enterpr...',
    order: 0,
    talks: ['57698d52-a898-4248-8b08-6196ba36d57a']
  },
  {
    id: 'ac8ffdef-fcab-41cd-b48a-50d66bf71acc',
    company: 'Masaryk University & Czechitas',
    country: 'Czech Republic',
    featured: true,
    isConfirmed: true,
    longDesc:
      'Barbora Buhnova is an Associate Professor and Vice-Dean at Masaryk University (MU), Faculty of Informatics (FI MU) in Brno. Following her research stays in Germany and Australia, she now leads multiple research teams at Faculty of Informatics MU (software architecture) and Czech CyberCrime Centre of Excellence C4e (critical infrastructures). She is the chair of the Association of Industrial Partners at FI MU (with 30 companies) and stands behind numerous courses reflecting modern technologies that she introduced at FI MU. Next to her academic activities, she is passionate about tech education among general public, being a Co-Founding and Governing Board member of Czechitas, a non-profit organisation aiming at making IT skills more accessible to youth and women (with 30,000+ graduates). ',
    name: 'Barbora Buhnova',
    photo:
      'https://www.openslava.sk/images/2022/barbora_buhnova_ac8ffdef-fcab-41cd-b48a-50d66bf71acc.jpg',
    shortDesc: 'Barbora Buhnova is an Associate Professor and ...',
    order: 850,
    talks: ['80f940d6-72e6-4a55-af75-43e8b7265951', 'ff889dd3-70ec-4564-879a-ef1ee7cc41e3']
  },
  {
    id: 'b4693c6a-e519-4277-bfae-48d81ffa2a15',
    company: 'Accenture',
    country: 'United Kingdom',
    featured: true,
    isConfirmed: true,
    longDesc:
      'As the Global Lead of Consumer Metaverse Technology, Fadi has been instrumental to building Accenture’s thought leadership and approach to the Metaverse with particular attention to consumers. He has been advocating it since Nov 2020 and is helping clients in a host of industries like Fashion, Teleco, Government, Banks, and Media navigate their paths to success in this new spatial medium. Fadi is working with them on creating meaningful narratives for their brands, designing strategic value propositions for their business, and defining the most optimal technical solutions to deliver.   Fadi is a thought leader in the immersive experience design space. He has introduced a new design mindset for XR, 3D web and the Metaverse that moves away from focusing as “users” to more looking at them as “participants” in spatial experiences. He has introduced the concepts of Spatial Experience (SX), Participant Experience (PX) and Perception Design, and he is developing the framework to help designers create truly compelling experiences for virtual and augmented worlds.  ',
    name: 'Dr Fadi Chehimi',
    photo:
      'https://www.openslava.sk/images/2022/dr_fadi chehimi_b4693c6a-e519-4277-bfae-48d81ffa2a15.jpg',
    shortDesc: 'As the Global Lead of Consu...',
    order: 975,
    talks: ['e5b6508a-3ee0-489f-a95d-54c79e604e77']
  },
  {
    id: '4f0a3cb8-b252-4114-bb2d-43e57fc7b5f2',
    company: 'Accenture',
    country: 'France',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Christian leads GTM Robotics activities at Accenture Tech Incubation, working at the intersection of human, business and technology trends to imagine and launch the next generation of robots in industrial and non-industrial domains (Retail, CPGs, Bank, Utilities, Smart Cities). Christian will specifically foster innovation, sustainability, inclusion and positive impact for society through robotics and creativity.',
    name: 'Christian Souche',
    photo:
      'https://www.openslava.sk/images/2022/christian_souche_4f0a3cb8-b252-4114-bb2d-43e57fc7b5f2.jpg',
    shortDesc: 'Christian leads GTM Robotic...',
    order: 0,
    talks: ['98e10dc1-3c4b-4fc8-a276-1b2a4bbf342b']
  },
  {
    id: '93da93d0-6fdd-4984-9312-cd97482d48b6',
    company: 'Google Cloud',
    country: 'Romania',
    featured: true,
    isConfirmed: true,
    longDesc:
      'Dorian is a Customer Engineer for Google Cloud with a background on Analytics and Data working with both large enterprise as well as digital natives working with BigData, Analytics, ML. He is passionate about making the right image out of data, without creating a visual cacophony',
    name: 'Dorian Hodorogea',
    photo:
      'https://www.openslava.sk/images/2022/dorian_hodorogea_93da93d0-6fdd-4984-9312-cd97482d48b6.jpg',
    shortDesc: 'Dorian is a Customer Engine...',
    order: 860,
    talks: ['73c02df3-9e6c-44ea-896c-ede9a6a2f14d']
  },
  {
    id: '2936b9c2-a163-41ca-98c9-669fba8c03b7',
    company: 'Accenture',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Lukas Jusko is Tech Arch Delivery Manager with experience in leading full stack development teams in several different industries. His main passion and primary focus is on modern lightweight architectures.',
    name: 'Lukas Jusko',
    photo:
      'https://www.openslava.sk/images/2022/lukas_jusko_2936b9c2-a163-41ca-98c9-669fba8c03b7.jpg',
    shortDesc: 'Lukas Jusko is Tech Arch Delivery Manager with...',
    order: 0,
    talks: ['773480f2-8509-4953-970e-bf23e444f240']
  },
  {
    id: 'edbc5832-77ed-4e58-93d8-2272208a74f5',
    company: 'Google Cloud ',
    country: 'Slovakia',
    featured: true,
    isConfirmed: true,
    longDesc:
      'Cloud stuff here, cloudy stuff there.  In love with getting 0s and 1s out of on-prem DCs and other clouds to GCP.  InfraMod Customer Engineer',
    name: 'Juraj Gvoth',
    photo:
      'https://www.openslava.sk/images/2022/juraj_gvoth_edbc5832-77ed-4e58-93d8-2272208a74f5.jpg',
    shortDesc: 'Cloud stuff here, cloudy st...',
    order: 960,
    talks: [
      '5c6f6baf-e274-4292-ac85-0576df708bc5',
      'b0b4e781-a0ba-47d4-b69d-7e3aee568e42',
      'b742749e-d88c-4925-8941-a8bf426c0145'
    ]
  },
  {
    id: 'c06feb54-fa4c-4789-9cf8-2bba2f82c1d1',
    company: 'Erste Digital',
    country: 'Austria',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Years of experience as system administrator and cloud engineer, in various Devops roles since then. Currently started new journey in Erste Digital in Platform and Automation Services department. ',
    name: 'Matus Kovacik',
    photo:
      'https://www.openslava.sk/images/2022/matus_kovacik_c06feb54-fa4c-4789-9cf8-2bba2f82c1d1.jpg',
    shortDesc: 'Years of experience as syst...',
    order: 0,
    talks: ['60bcd045-527c-40fc-86b5-1fff96f1542e']
  },
  {
    id: '087335a0-7179-4baa-a49f-f51af3cc4c02',
    company: 'Takeda',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Enterprise Solution Architect that helps to define way of democratizing and operationalizing data for its usage within manufacturing, supply chain and quality. Aligning it with enterprise architecture strategy for getting sustainable and operable architecture. Big fan of Public Cloud ecosystems.',
    name: 'Karol Lacuska',
    photo:
      'https://www.openslava.sk/images/2022/karol_lacuska_087335a0-7179-4baa-a49f-f51af3cc4c02.jpg',
    shortDesc: 'Enterprise Solution Archite...',
    order: 0,
    talks: ['7cf654ff-0f3c-4c3c-839d-c9320901924a']
  },
  {
    id: '5c39a60f-46ee-46f4-bc82-4cfe11f4e3fa',
    company: 'Accenture Austria',
    country: 'Austria',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Georgia is a Technology Architect and member of the Enterprise Architecture group in Accenture. She has worked as a software architect and developer in the past years, using various technologies ranging from JavaScript full-stack development to cloud infrastructure.',
    name: 'Georgia Moldovan',
    photo:
      'https://www.openslava.sk/images/2022/georgia_moldovan_5c39a60f-46ee-46f4-bc82-4cfe11f4e3fa.jpg',
    shortDesc: 'Georgia is a Technology Arc...',
    order: 0,
    talks: ['57698d52-a898-4248-8b08-6196ba36d57a']
  },
  {
    id: 'e199773c-8c33-4464-8aa9-ee329b485b7a',
    company: 'Accenture',
    country: 'Switzerland',
    featured: true,
    isConfirmed: true,
    longDesc: 'Andy Nice is leading the XR and Metaverse practice in ASG',
    name: 'Andy Nice',
    photo:
      'https://www.openslava.sk/images/2022/andy_nice_e199773c-8c33-4464-8aa9-ee329b485b7a.jpg',
    shortDesc: 'Andy Nice is leading the XR...',
    order: 920,
    talks: ['c4df7896-9f2f-463f-80c1-fb0787576026']
  },
  {
    id: 'dc770d8c-b286-4307-8f1a-e566bd6fb378',
    company: 'Erste Digital',
    country: 'Austria',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Pavel Mocan is a product oriented software engineer passionate about Web Development, Behavioral Driven Development and Clean Code. He has more than 10 years of professional experience within digital agencies, startups and corporations. Apart from his day-to-day work, Pavel loves solving problems, teaching others about programming and doing woodworking.',
    name: 'Pavel Mocan',
    photo:
      'https://www.openslava.sk/images/2022/pavel_mocan_dc770d8c-b286-4307-8f1a-e566bd6fb378.jpg',
    shortDesc: 'Pavel Mocan is a product or...',
    order: 0,
    talks: ['1aca1163-b66e-45a4-ae5d-c61403427c46']
  },
  {
    id: 'ceb23dec-010c-4409-9239-1ed1646e41e9',
    company: 'Accenture',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Vladimir is a technology architect from Accenture focusing on cloud and artificial intelligence solutions. He is working as an architect for large banking client as part of their innovation studio and leading architecture community in our Bratislava office.',
    name: 'Vladimir Hlavacek',
    photo:
      'https://www.openslava.sk/images/2022/vladimir_hlavacek_ceb23dec-010c-4409-9239-1ed1646e41e9.jpg',
    shortDesc: 'Vladimir is a technology ar...',
    order: 0,
    talks: ['773480f2-8509-4953-970e-bf23e444f240']
  },
  {
    id: 'b3423919-9b59-4c39-a47b-28f5235a0a1b',
    company: 'Accenture',
    country: 'Germany',
    featured: true,
    isConfirmed: true,
    longDesc:
      "Dr. Sebastian Senge co-leads Accenture's Quantum Computing (QC) team in the ASG (DACH) region and is part of Accenture’s Global Technology Innovation Quantum Computing practice. He incubates and drives technology innovation ideas & visions with a strong focus and passion for delivering QC & AI projects – from strategy to implementation. He acts as a speaker and moderator at QC conferences and focuses on QC & AI algorithms.  He has more than 13 years of professional IT experience and holds a Diploma in Computer Science, earned his PhD in an Artificial Intelligence topic. ",
    name: 'Sebastian Senge',
    photo:
      'https://www.openslava.sk/images/2022/sebastian_senge_b3423919-9b59-4c39-a47b-28f5235a0a1b.jpg',
    shortDesc: 'Dr. Sebastian Senge co-lead...',
    order: 890,
    talks: ['68097f83-ae6f-4b2a-bccb-aeb7a298ed5f']
  },
  {
    id: 'aafd62db-dd54-46ab-9040-4d105eb93762',
    company: 'Accenture',
    country: 'France',
    featured: true,
    isConfirmed: true,
    longDesc:
      'Laetitia Cailleteau, Managing Director for Accenture, is leading Accenture’s Data & AI business in Europe and the conversational AI domain globally – driving innovation, sales and delivery across the globe for multiple industries and clients . She has more than 20 years’ experience in the consulting industry, authored several academic publications and hold patents in the conversational AI domain area. She founded the Liquid Studio in London, a space where her team co-create with clients to realise the potential of artificial intelligence, augmented reality, IoT, using user-centred approaches. She is a reserve member of the Artificial Intelligence High Level Group at the European Commission.',
    name: 'Laetitia Cailleteau',
    photo:
      'https://www.openslava.sk/images/2022/laetitia_cailleteau_aafd62db-dd54-46ab-9040-4d105eb93762.jpg',
    shortDesc: 'Laetitia Cailleteau, Managi...',
    order: 885,
    talks: ['f090a654-dbd4-4905-b6d3-09e3162c0995', 'ff889dd3-70ec-4564-879a-ef1ee7cc41e3']
  },
  {
    id: '69b25f0a-9b4f-4987-bc05-9facc8080810',
    company: 'Avanade',
    country: 'United Kingdom',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Josie West is a Director and AI&IOT Offering Lead for UK and Ireland within Avanade. Her recent focus has been to explore the truth and business value behind technologies such as Digital Twin and The Metaverse and explore why and where they can help our Global Economy. An Avanade coined proposition, Digital Cognition, is a combination of technologies that enable the power of data to solve sustainability problems and complex systems. This is gaining traction and interest amongst world leading organisations and Josie will be taking us through this at Open Slava 2022.',
    name: 'Josie West',
    photo:
      'https://www.openslava.sk/images/2022/josie_west_69b25f0a-9b4f-4987-bc05-9facc8080810.jpg',
    shortDesc: 'Josie West is a Director an...',
    order: 0,
    talks: ['0ac7c123-ab98-42b9-b35a-dec11c507ca5']
  },
  {
    id: 'ca2607b8-3e62-4625-9cdc-e5cbf2094ee4',
    company: 'Accenture',
    country: 'United Kingdom ',
    featured: true,
    isConfirmed: true,
    longDesc:
      'Nick Rosa is a creative technologist, experience designer, and digital transformation specialist, who previously worked for Google, Spotify, IBM IX, Yahoo!, and Atari; and is now part of Accenture in their Metaverse Continuum Business Group, where he is the Metaverse Strategy Lead for Europe & APAC. Nick is also the chairman of the British Interactive Media Association (BIMA) council for Immersive Technologies; and a Director at the Academy of International Extended Reality (AIXR), a non-profit entity producing the annual VR Awards. He is the co-host and co-author of a podcast series called “Field of View”, where he interviews entrepreneurs, researchers, and pioneers in the field of Extended Reality and the Metaverse and is available on all the major platforms, including YouTube, Spotify, and Apple Music. Nick’s first book “Understanding the Metaverse: A Business and Ethical Guide” will be published worldwide by Wiley on the 24th of October 2022.',
    name: 'Nicola Rosa',
    photo:
      'https://www.openslava.sk/images/2022/nicola_rosa_ca2607b8-3e62-4625-9cdc-e5cbf2094ee4.jpg',
    shortDesc: 'Nick Rosa is a creative tec...',
    order: 999,
    talks: ['02f1a1ce-9bd5-44aa-9c23-77c963b6ba41']
  },
  {
    id: '7c244790-59af-4f96-ab98-e46728816585',
    company: 'Accenture',
    country: 'Germany',
    featured: false,
    isConfirmed: true,
    longDesc:
      "Björn Obermeier is the Global Blockchain Capability Lead within Accenture's Metaverse Continuum Business Group and helps to empowering the Metaverse with Blockchain and distributed systems. He has 20+ years of IT industry experience and explores the “art of the possible” with corporations to create competitive advantage and to unlock business value.",
    name: 'Björn Obermeier',
    photo:
      'https://www.openslava.sk/images/2022/björn_obermeier_7c244790-59af-4f96-ab98-e46728816585.jpg',
    shortDesc: 'Björn Obermeier is the Glob...',
    order: 0,
    talks: ['a0037058-d17c-433d-b6a8-9cc88d5c6528']
  },
  {
    id: 'f35bbaff-d46a-4315-8f5c-71e751424a8f',
    company: 'Accenture',
    country: 'Slovakia',
    featured: true,
    isConfirmed: true,
    longDesc:
      'Branislav with more than 25 years in IT is a part of Accenture Danubia Advanced Technology Center in SK/Bratislava. Is primarily focused on Data Science, ML/AI and Oracle Cloud. Branislav Majerník gained strong experience in Data Science, ML and Oracle Cloud Infrastructure . He holds a Dr., MSc. in physics of the Faculty Mathematics, Physics and Informatics of Comenius University in Bratislava.',
    name: 'Branislav Majerník',
    photo:
      'https://www.openslava.sk/images/2022/branislav_majerník_f35bbaff-d46a-4315-8f5c-71e751424a8f.jpg',
    shortDesc: 'Branislav with more than 25...',
    order: 950,
    talks: ['49f2c147-697e-410e-9d35-b2b611acd361', '860ee988-f2c2-4300-a51b-e29442cfdc23']
  },
  {
    id: '158dec14-4a45-4580-91b1-cf7852168b61',
    company: 'Accenture',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Richard Voros is technology senior manager at Accenture Bratislava, passionate about sustainability, inclusion and diversity and technology in general. As a sustainability lead his vision is to enable our technology centers in Slovakia, Hungary, Romania and Czech Republic to support our clients on their journey to sustainable business models and achieving their sustainability goals.',
    name: 'Richard Voros',
    photo:
      'https://www.openslava.sk/images/2022/richard_voros_158dec14-4a45-4580-91b1-cf7852168b61.jpg',
    shortDesc: 'Richard Voros is technology...',
    order: 0,
    talks: [
      '22289a48-9d61-427b-a44b-cc24be1b9608',
      'dacc2b0c-95f1-45dd-819e-51091f07b68b',
      'ff889dd3-70ec-4564-879a-ef1ee7cc41e3'
    ]
  },
  {
    id: '3fa8b9a0-086c-4991-ba1b-cab2d04191e0',
    company: 'Red Hat',
    country: 'Germany',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Before joining Red Hat, Max Murakami was researching AI in the context of intrinsic motivation and autonomous learning. He then joined the IT industry and worked in ML engineering where he developed containerized micro services, integrated deep learning models, and looked after delivery and production of an NLP-based intelligent application. He is now a Specialist Solution Architect at Red Hat and helps customers tap into OpenShift as an AI platform to empower their data scientists and operationalize their machine learning workloads.',
    name: 'Max Murakami',
    photo:
      'https://www.openslava.sk/images/2022/max_murakami_3fa8b9a0-086c-4991-ba1b-cab2d04191e0.jpg',
    shortDesc: 'Before joining Red Hat, Max...',
    order: 0,
    talks: ['3c0cab80-3735-4c51-b781-a1b45645e31e', 'b1e5079a-8cf4-4342-86fb-372f40c9e41f']
  },
  {
    id: 'e73e8286-7b43-4c39-ab5f-8a1d954a3176',
    company: 'Accenture',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Katarína is an Innovation Sherpa and a member of the Client Innovation Studio team based in Accenture Bratislava. She focuses on technological innovations implemented within Accenture with an emphasis on their presentation to client visits in accordance with innovative methods. Katarína intensively and passionately facilitates Design Thinking sessions with 4 years of experience. Katarína also has 10 years of experience in management consulting with a focus on investment projects, project feasibility (market and financial evaluation) and marketing strategies.',
    name: 'Katarína Košč',
    photo:
      'https://www.openslava.sk/images/2022/katarína_košč_e73e8286-7b43-4c39-ab5f-8a1d954a3176.jpg',
    shortDesc: 'Katarína is an Innovation S...',
    order: 0,
    talks: ['81deeef0-b68a-4ed5-bfc3-d95a31be0ae1']
  },
  {
    id: '858c16bf-5347-4bc5-a026-a5277d479dcb',
    company: '---',
    country: 'USA',
    featured: false,
    isConfirmed: true,
    longDesc:
      "I write code, front end and back-end, and like deploying it on AWS. Software Developer for 20 years, and still love it. Freelanced, worked with startups, attempted my own software products, ran a consulting shop with some partners, consulted at large enterprises with Accenture & Capital One, and now write software at Koalafi.  Career has mostly been all about building UI's.  Started with Director and Lingo. First job, I transitioned over to Flash and ActionScript to make working with designers easier. As my programming skills grew, I transitioned to Flex to take on larger software projects. When Flash Player died because of the iPhone, I transitioned to JavaScript and Backbone, then Angular, then React, and now Elm. I also started doing more back-end API and BFF work using Node.js. Past 4 years I've been focused on Functional Programming and serverless using AWS Amplify, AppSync + GraphQL, and Lambda.  I love the conference circuit and continue to love speaking all around the world at various user groups, conferences, and workshops. Speaking about tech you are passionate about in front of large, eager groups of strangers is intoxicating.  I always try to blog my learning experiences in hopes it'll help others learn it faster and easier than I did at https://jessewarden.com. I also like creating YouTube videos on my channel https://www.youtube.com/channel/UCzBDmYcmynHX7mELvD0sWEA to help people learn both beginner and advanced programming... but mostly to make them laugh. And learn.  Outside of tech, I alternate between Bodybuilding, Powerlifting, and Backpacking. I love Parkour when it's warm outside.  You had me at “Elm, FP, Lambda, Step Functions, and free coffee...“",
    name: 'Jesse Warden',
    photo:
      'https://www.openslava.sk/images/2022/jesse_warden_858c16bf-5347-4bc5-a026-a5277d479dcb.jpg',
    shortDesc: 'I write code, front end and...',
    order: 0,
    talks: ['599ddc16-d03c-4ad0-9a39-b3ef3a83471d']
  },
  {
    id: '6c77f847-47c2-4e76-9364-773cdc757098',
    company: 'VUB Banka',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Skilled IT professional with proven track of experiences how to implement large and complex projects from various domains (mainly Telco and Finance ). Passionate about security, identity management, data science, API management, open source, new technologies and architecture modelling. In addition to solution architecture, enhancing skills in architecture development and governance. As an Enterprise architect touching also non-IT areas such as strategy and operational planning. Committed to the principles of openness, innovation, cooperation and knowledge sharing ',
    name: 'Tomas Hornicek',
    photo:
      'https://www.openslava.sk/images/2022/tomas_hornicek_6c77f847-47c2-4e76-9364-773cdc757098.jpg',
    shortDesc: 'Skilled IT professional wit...',
    order: 0,
    talks: ['a50142b6-863b-4cfc-9f3e-a4c901c7f56c']
  },
  {
    id: '5fd95a92-7b7b-4ff5-a3f9-491f064c431f',
    company: 'Google Cloud',
    country: 'Czech Republic',
    featured: false,
    isConfirmed: true,
    longDesc:
      'I am a lazy person, so I like to create and reuse effectively designed automatized systems, processes and jobs. InfraMod Customer Engineer',
    name: 'Pavel Krejsa',
    photo:
      'https://www.openslava.sk/images/2022/pavel_krejsa_5fd95a92-7b7b-4ff5-a3f9-491f064c431f.jpg',
    shortDesc: 'I am a lazy person, so I l...',
    order: 0,
    talks: ['b0b4e781-a0ba-47d4-b69d-7e3aee568e42']
  },
  {
    id: '50ff3762-b973-4242-8a4d-5788af06b827',
    company: 'Accenture',
    country: 'Germany',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Tim is part of the global technology innovation quantum computing team and serves as ASG (Austria, Switzerland, Germany) quantum computing lead in the technology incubation team to advise on go-to-market strategies and deliver quantum computing applications. He gained 3 years of end-to-end quantum technology innovation and advanced analytics delivery experience with cross-industry consortia, a financial services company in Germany, and a products client in Spain. He holds a double M.Sc. in physics, and economics, business & management from RWTH Aachen and joined Accenture after 5 years in silicon quantum computing in Aachen and Shanghai.',
    name: 'Tim Leonhardt',
    photo:
      'https://www.openslava.sk/images/2022/tim_leonhardt_50ff3762-b973-4242-8a4d-5788af06b827.jpg',
    shortDesc: 'Tim is part of the global technology innovatio...',
    order: 0,
    talks: ['e1935fa1-425e-4879-85ee-0e9398600692']
  },
  {
    id: 'de2bce3a-c36b-4abb-9159-566a9132278c',
    company: 'Erste Digital',
    country: 'Austria',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Nik Sumeiko is a software engineer and architect with over 17 years of professional experience. He works on payment systems at George, the digital banking solution of Erste Group. Beyond programming, Nik trains web developers in-house, at enterprise companies all over Europe, and on LinkedIn.',
    name: 'Nik Sumeiko',
    photo:
      'https://www.openslava.sk/images/2022/nik_sumeiko_de2bce3a-c36b-4abb-9159-566a9132278c.jpg',
    shortDesc: 'Nik Sumeiko is a software e...',
    order: 0,
    talks: ['1aca1163-b66e-45a4-ae5d-c61403427c46']
  },
  {
    id: '14feb7b1-28e5-4abe-9629-adbdd996ecf5',
    company: 'ErsteDigital',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc:
      'I have been working with data for several years, but main focus on is to prepare data to further exploration.  Before jumped-in to hadoop technology I worked on Data warehouse.',
    name: 'Ivan Liscinsky',
    photo:
      'https://www.openslava.sk/images/2022/ivan_liscinsky_14feb7b1-28e5-4abe-9629-adbdd996ecf5.jpg',
    shortDesc: 'I have been working with da...',
    order: 0,
    talks: ['481cf0cd-db66-496e-95f5-a7dbc95e6bed']
  },
  {
    id: '219edef2-93ee-436f-a1a0-79e53b5eece1',
    company: 'Accenture',
    country: 'Germany',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Philip is a passionate quantum computing enthusiast and has experience in quantum machine learning, quantum optimization, and quantum algorithms. He works as a quantum computing software engineer at Accenture to help companies see the possibilities quantum technology could bring. He studied computer science and physics and is excited to share his knowledge.',
    name: 'Philip Hierhager',
    photo:
      'https://www.openslava.sk/images/2022/philip_hierhager_219edef2-93ee-436f-a1a0-79e53b5eece1.jpg',
    shortDesc: 'Philip is a passionate quan...',
    order: 0,
    talks: ['2b64bc95-4e61-44bd-b4d9-55e6b10f68e1']
  },
  {
    id: 'a57e8e14-cb53-4e0b-9ca1-18ed1e5b2643',
    company: 'launchlabs',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Stefan is the Managing Director at Launchlabs Bratislava, he has 14 years of experience in solving business challenges for clients in various industries. Stefan is Design Thinking facilitator, trainer and ambassador, as well as winter sports enjoyer.',
    name: 'Štefan Meszároš ',
    photo:
      'https://www.openslava.sk/images/2022/štefan_meszároš _a57e8e14-cb53-4e0b-9ca1-18ed1e5b2643.jpg',
    shortDesc: 'Stefan is the Managing Dire...',
    order: 0,
    talks: ['81deeef0-b68a-4ed5-bfc3-d95a31be0ae1']
  },
  {
    id: '3021d7a2-6a2e-4788-aec5-64c8dd19e330',
    company: 'Accenture',
    country: 'Germany',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Tom studied physics and joined Accenture as part of the quantum team one year ago. In this time, he has used his theoretical knowledge and built practical skills in additional to that on different quantum computing projects in Accenture. He was part of the winning team of the BMW/AWS quantum challenge and supported QUTAC, the Quantum Technology & Application Consortium, in building real-world use case solutions.',
    name: 'Tom Endres',
    photo:
      'https://www.openslava.sk/images/2022/tom_endres_3021d7a2-6a2e-4788-aec5-64c8dd19e330.jpg',
    shortDesc: 'Tom studied physics and joi...',
    order: 0,
    talks: ['2b64bc95-4e61-44bd-b4d9-55e6b10f68e1']
  },
  {
    id: '831076b5-3c4d-4dca-8683-bc3181b7572c',
    company: 'VÚB a.s.',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Senior IT manager with background from finance and insurance, passionate about customer experience, agile and design thinking principles. Focusing these days on IT optimization, digitalization, automatization of repetitive jobs/tasks and on bringing focus on customers and ESG in large corporations.',
    name: 'Jaroslav Vojcik',
    photo:
      'https://www.openslava.sk/images/2022/jaroslav_vojcik_831076b5-3c4d-4dca-8683-bc3181b7572c.jpg',
    shortDesc: 'Senior IT manager with background from finance...',
    order: 0,
    talks: ['ff889dd3-70ec-4564-879a-ef1ee7cc41e3']
  },
  {
    id: 'e495e093-cdf5-4f28-a5a3-f2d18e7d9e5a',
    company: 'Siemens AG',
    country: 'Germany',
    featured: true,
    isConfirmed: true,
    longDesc:
      'Timo is Enterprise Software Architect at Siemens Building Products, focusing on user experience and front-end technologies for web and mobile development. In collaboration with a global core team he develops a Siemens-wide platform, based on Angular and Ionic, to streamline frontend development with common shared components, best development practices and support for multiple UX designs. In addition, he coaches various product development teams and feeds back requirements to the central platform. Timo is a Siemens Social Coding Ambassador fostering open collaboration across organizational boundaries like open source projects do.',
    name: 'Dr. Timo Wolf',
    photo:
      'https://www.openslava.sk/images/2022/dr._timo wolf_e495e093-cdf5-4f28-a5a3-f2d18e7d9e5a.jpg',
    shortDesc: 'Timo is Enterprise Software...',
    order: 870,
    talks: ['6f81f6b6-c3e4-48e4-a65a-4593797f5e54']
  },
  {
    id: '6c784115-1116-4452-b715-f937e4690639',
    company: 'Accenture ',
    country: 'Germany',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Andre is a technology enthusiast and a passionate speaker. He is a technology manager by Accenture. ',
    name: 'Andre Motz ',
    photo:
      'https://www.openslava.sk/images/2022/andre_motz _6c784115-1116-4452-b715-f937e4690639.jpg',
    shortDesc: 'Andre is a technology enthu...',
    order: 0,
    talks: ['beea103c-813c-4bac-9b89-e18d9594482d']
  },
  {
    id: 'ede9468a-0919-4b0c-a4d1-eb597a3186fe',
    company: 'Accenture',
    country: 'Austria',
    featured: false,
    isConfirmed: true,
    longDesc: 'Software Developer with a focus on Technology Architecture',
    name: 'Melissa Schmidt',
    photo:
      'https://www.openslava.sk/images/2022/melissa_schmidt_ede9468a-0919-4b0c-a4d1-eb597a3186fe.jpg',
    shortDesc: 'Software Developer with a f...',
    order: 0,
    talks: ['ab8475b5-9d7c-4bb0-bdd0-4a65ffb57996', 'e1935fa1-425e-4879-85ee-0e9398600692']
  },
  {
    id: '630e8104-24e3-4de9-9b47-d40ca1ca1b5e',
    company: 'Accenture',
    country: 'France',
    featured: true,
    isConfirmed: true,
    longDesc:
      "Ezio Armando is Accenture's Global Architecture Lead, responsible for the Accenture's architecture practice, thought leadership and investments.   He has 30 years of IT experience as Enterprise, Technology and Solutions Architect, 24 of which for Accenture, specialising in IT strategy and in shaping, planning, designing and delivery of high-availability, high-security, high-volume systems for some of the largest Accenture clients.  Ezio has an Master's degree in Computer Science and a Master's degree in Business Administration.",
    name: 'Ezio Armando',
    photo:
      'https://www.openslava.sk/images/2022/ezio_armando_630e8104-24e3-4de9-9b47-d40ca1ca1b5e.jpg',
    shortDesc: "Ezio Armando is Accenture's...",
    order: 910,
    talks: ['ee6ac54d-6ee7-49ef-a0a6-8d8e162298e8']
  },
  {
    id: '3117bdb6-363f-4a88-abc8-dd44126b1f56',
    company: 'Všeobecná úverová banka',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'Machine learning engineer, creating large scale DL models in a bank environment',
    name: 'Jakub Červeň ',
    photo:
      'https://www.openslava.sk/images/2022/jakub_červeň _3117bdb6-363f-4a88-abc8-dd44126b1f56.jpg',
    shortDesc: 'Machine learning engineer, ...',
    order: 0,
    talks: ['70f69c68-8d02-4399-8a15-35b74dc4a4a7']
  },
  {
    id: '26730903-ab37-4967-b89b-f60c35be453e',
    company: 'Accenture',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Peter is currently working as software architect at Accenture. Having scientific and entrepreneurial background, he now focuses on sustainability in IT and especially on what does it take to make software greener.',
    name: 'Peter Antal',
    photo:
      'https://www.openslava.sk/images/2022/peter_antal_26730903-ab37-4967-b89b-f60c35be453e.jpg',
    shortDesc: 'Peter is currently working ...',
    order: 0,
    talks: ['dacc2b0c-95f1-45dd-819e-51091f07b68b']
  },
  {
    id: '39d01aea-fe73-47cc-898a-f13f3067cebf',
    company: 'Red Hat ',
    country: 'Italy',
    featured: false,
    isConfirmed: true,
    longDesc:
      'I am a Solution Architect in Red Hat working with Global System Integrators to engage them on topics like Hybrid Cloud approach, AI/ML, Edge Computing.  I am also one of the Openshift.tv coffee break producer ',
    name: 'Fabio DI Vita',
    photo:
      'https://www.openslava.sk/images/2022/fabio_di vita_39d01aea-fe73-47cc-898a-f13f3067cebf.jpg',
    shortDesc: 'I am a Solution Architect i...',
    order: 0,
    talks: ['294e561b-d66c-4661-879d-4a5da54a8793', '90ea097a-1f30-4c77-8f09-f2efe7b5fc63']
  },
  {
    id: 'a94a2ace-93c7-4f40-a612-7a9720157889',
    company: 'Accenture',
    country: 'Denmark',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Usman has worked for nearly 15 years within IT in various fields from Software Development, Project Management, Cloud Journeys/transformations and DevOps / Operations. A key focus has been to work in teams of highly technical people as a team member and technical lead and help bridge the gaps between IT and Business, while still getting his fingers into new technical areas.',
    name: 'Usman Mir',
    photo:
      'https://www.openslava.sk/images/2022/usman_mir_a94a2ace-93c7-4f40-a612-7a9720157889.jpg',
    shortDesc: 'Usman has worked for nearly...',
    order: 0,
    talks: ['de3b866e-8c7c-4489-a1df-9024bc399f14']
  },
  {
    id: '9bf1e3fc-b9f0-48fe-a1f6-76c2a3d8260f',
    company: 'Accenture',
    country: 'Israel',
    featured: true,
    isConfirmed: true,
    longDesc:
      "Prof. Dr. Ethan Hadar is the Chief Research Officer for Accenture Labs - Europe, the company's dedicated RD organization, driving scientific advances and co-research activities with clients, partners, and universities across Europe. Prof. Hadar is also the Managing Director for Accenture’s Center-of-Excellence Labs for applied AI, located in Israel, as well as leading a global research team for distributed data analytics and cross-industry implementations over the edge-to-cloud continuum. His 30 years of experience in addition to Accenture was at global organizations including CA Technologies, AGT, HP, and IBM.  During this time, he served in various capacities including CTO, SVP, and Distinguished Engineer among other roles. His proven expertise is in merging organic innovation with research from universities and startups technology, extending core and forming new solutions, while providing long term technical strategic guidance to the executive leadership. He is a Professor-of-Practice in Software Engineering and Information Systems. He has a PhD in Operations Research and M.Sc. in Mechatronics (mechanical, electronics, mathematics, robotics and computer science engineering) from the Technion, Israel Institute of Technology. He is also a faculty member at Zefat Academic College. During his career, Prof. Hadar formed high performing innovative science and engineering teams and created first-of-a-kind valuable solutions and IP in the areas of Distributes Data, Digital Twins, Data Sciences and AI, Software Architecture, Security and Computer Vision, ramping up current and future business services and products. His work to date has yielded 149 patents and publications. ",
    name: 'Prof. Dr. Ethan Hadar',
    photo:
      'https://www.openslava.sk/images/2022/ethan_hadar_9bf1e3fc-b9f0-48fe-a1f6-76c2a3d8260f.jpg',
    shortDesc: 'Prof. Dr. Ethan Hadar is th...',
    order: 900,
    talks: ['ae39133f-9901-4f52-98c3-6ae97783ec42']
  },
  {
    id: 'dedd4b05-258f-46bd-bba1-bf4d93586b67',
    company: 'Photoneo',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Marcel Svec studied Artificial Intelligence at the Faculty of Mathematics, Physics and Informatics in Bratislava and Lisbon. He joined Photoneo in its early stages in 2016 originally as a programmer. Together with the fast growth of Photoneo Marcel went through the role of Application Engineer establishing technical relationships with partners all over the world, continued to the role of Director of 3D Sensing, and now acts as a VP of Product & Strategy for sensor and intelligence products.',
    name: 'Marcel Svec',
    photo:
      'https://www.openslava.sk/images/2022/marcel_svec_dedd4b05-258f-46bd-bba1-bf4d93586b67.jpg',
    shortDesc: 'Marcel Svec studied Artific...',
    order: 0,
    talks: ['c8ca230d-3164-436a-abb7-ccfeb8284fc7']
  },
  {
    id: '13336ac0-34c9-4e9f-83b2-007481824a66',
    company: 'Google',
    country: 'Romania',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Horia is a passionate data enthusiast and loves to help organizations grow through the use of data. He joined Google after spending over 15 years helping organizations up their data game. His battle tested expertise covers both start-ups and large corporations, with a focus on the retail and banking sectors. He believes that to understand technology, one needs to use it first-hand. His favorite parts of the daily routine are the high level architecture design and the low level coding and problem solving.',
    name: 'Horia Niculescu',
    photo:
      'https://www.openslava.sk/images/2022/horia_niculescu_13336ac0-34c9-4e9f-83b2-007481824a66.jpg',
    shortDesc: 'Horia is a passionate data ...',
    order: 0,
    talks: ['031f8a36-d906-4981-a03c-3c5e7f6b71ed']
  },
  {
    id: '9ea119a0-af98-4f97-a7c2-4f55eec98531',
    company: 'Accenture',
    country: 'Germany',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Falk Schaefer leads Accenture Technology Innovation Robotics activities in Germany, Austria and Switzerland and a team of IT/OT software engineers in Germany. He is involved in several activities and projects in the area of connected services, digital factory and autonomous robotics systems with a focus on strategy, digital platforms and technology architecture.',
    name: 'Falk-Moritz Schaefer',
    photo:
      'https://www.openslava.sk/images/2022/falk-moritz_schaefer_9ea119a0-af98-4f97-a7c2-4f55eec98531.jpg',
    shortDesc: 'Falk Schaefer leads Accentu...',
    order: 0,
    talks: ['7c62d310-4c2c-40dc-b6d3-894f2350558e']
  },
  {
    id: '1c5f8915-abfc-43a4-85d3-90bb0c78b7fd',
    company: 'Institute of Physics, Slovak Academy of Sciences',
    country: 'Slovakia',
    featured: true,
    isConfirmed: true,
    longDesc:
      'Prof. Dr. Vladimír Bůžek, DrSc. graduated from the Moscow State University (both MSc and PhD in 1982 and 1985, respectively). His research interests have been focused primarily on theoretical quantum optics and quantum information sciences.  He is best known for his work on the reconstruction of quantum states and processes from incomplete experimental data, programmable quantum processors, quantum cloning, novel algorithms for quantum secret sharing and quantum voting protocols. He published more than 230 research papers and 15 chapters in books cited in the scientific literature more than 17 500 times (h-index 63). He works at the Institute of Physics, Slovak Academy of Sciences. Over the years he has been a visiting professor at a number of academic institutions including the Imperial College, London (UK), National University of Ireland, Maynooth (Ireland), University of Ulm (Germany), SOKEN (Japan), University of Queensland (Australia), Sogang University (South Korea), INAOE Mexico, Pontificia Universidad Católica de Chile, etc. Prof. Bužek was the president of the Learned Society of the Slovak Academy of Sciences, he is a foreign corresponding member of the Austrian Academy of Sciences and a member of the Academia Europaea. He was a vice-president of the John Templeton Foundation. He is a fellow of the Institute of Physics (UK) and the Optical Society of America (USA). ',
    name: 'Prof. Dr. Vladimír Bužek',
    photo:
      'https://www.openslava.sk/images/2022/vladimír_bůžek_1c5f8915-abfc-43a4-85d3-90bb0c78b7fd.jpg',
    shortDesc: 'Prof. Dr. Vladimír Bůžek, D...',
    order: 955,
    talks: ['860ee988-f2c2-4300-a51b-e29442cfdc23']
  },
  {
    id: '67d7e9a4-e5be-4c97-9e0a-a81ca653ff87',
    company: 'Red Hat',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc:
      "I'm Principal Software Engineer at Red Hat, creator and maintainer of Java Operator SDK. In a wider scope currently focusing on Java developer experience on Kubernetes. I'm a passionate Java developer but in addition to that last six years also focusing on server side solutions. As a freelancer I was also part of brilliant platform teams, building platforms mostly on top of Kuberentes/Openshift and AWS. I try to focus on the complete picture of the server side solutions.",
    name: 'Attila Mészáros',
    photo:
      'https://www.openslava.sk/images/2022/attila_mészáros_67d7e9a4-e5be-4c97-9e0a-a81ca653ff87.jpg',
    shortDesc: "I'm Principal Software Engi...",
    order: 0,
    talks: ['7ba7e3b0-676c-4e9d-942b-40927af7d1b1']
  },
  {
    id: 'a87d6921-cf83-4215-9207-26f667e30098',
    company: 'Erste Digital',
    country: 'Austria',
    featured: false,
    isConfirmed: true,
    longDesc:
      "Software engineer with a passion for automation, 5 years of experience in full stack development with various technologies, since 10 months for Erste Digital within the Platform & Automation Services department. Currently doing my Business Informatics master's in Vienna at UAS Technikum Wien. ",
    name: 'Moritz Schrom',
    photo:
      'https://www.openslava.sk/images/2022/moritz_schrom_a87d6921-cf83-4215-9207-26f667e30098.jpg',
    shortDesc: 'Software engineer with a pa...',
    order: 0,
    talks: ['60bcd045-527c-40fc-86b5-1fff96f1542e']
  },
  {
    id: 'f3282e69-a540-4598-b9f7-f57d4f411bd0',
    company: 'Accenture',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Gabriela is Fullstack Engineering Specialist at Accenture. Although her specialisation is backend and frontend technologies, she has done fair share on DevOps too.',
    name: 'Gabriela Gadova',
    photo:
      'https://www.openslava.sk/images/2022/gabriela_gadova_f3282e69-a540-4598-b9f7-f57d4f411bd0.jpg',
    shortDesc: 'Gabriela is Fullstack Engin...',
    order: 0,
    talks: ['e5d4990b-1286-46ba-9215-b877c1700eda']
  },
  {
    id: '5a6d136e-c11b-4841-bbe9-eb7098d23189',
    company: 'Accenture',
    country: 'France',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Emmanuel Viale is the Managing Director of the Accenture Technology Innovation organization in Europe: Labs, Ventures, Technology Incubation and the Liquid Studios. He is based in Sophia Antipolis, France where He leads the different R&D activities of the Labs nodes in Europe (Dublin, Tel Aviv and Sophia Antipolis) with a particular focus on identifying, incubating, applying and delivering applications of innovative and emerging technologies. He also leads the Liquid Studios in Europe.',
    name: 'Emmanuel Viale',
    photo:
      'https://www.openslava.sk/images/2022/emmanuel_viale_5a6d136e-c11b-4841-bbe9-eb7098d23189.jpg',
    shortDesc: 'Emmanuel Viale is the Manag...',
    order: 0,
    talks: ['def210ee-5089-4435-919f-7b688c4a0ae9']
  },
  {
    id: 'f8c1d95e-8459-4c0a-85dd-08b115a32538',
    company: 'Accenture',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Juraj is the Lead of Innovations across our Accenture Advanced Technology Centers in Slovakia, Hungary and Romania. He leads the Client Innovation Studio in Bratislava with its Liquid Studio and NanoLab focused on introducing the new technologies to our clients to achieve their business goals through co-creation and co-innovation practices including Design Thinking. He recently built the XR and Metaverse practices locally and connected the local teams with the global Accenture Metaverse Continuum Business Group. Juraj has 20 years of experience in IT, mainly with the delivery management practices ranging from small projects to large multi-site System Integration and Application Outsourcing BSS programs.',
    name: 'Juraj Schmidt',
    photo:
      'https://www.openslava.sk/images/2022/juraj_schmidt_f8c1d95e-8459-4c0a-85dd-08b115a32538.jpg',
    shortDesc: 'Juraj is the Lead of Innova...',
    order: 0,
    talks: ['81deeef0-b68a-4ed5-bfc3-d95a31be0ae1']
  },
  {
    id: '48ac7fdc-96b4-474d-8dce-0d9813b22444',
    company: 'Red Hat',
    country: 'France',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Jan is a Senior Solutions Architect at Red Hat, working closely with Accenture as part of the EMEA GSI Alliances team. He previously worked for 9+ years at Accenture being a part of the Accenture - Red Hat Business Group where he held the position of EMEA Technology & Architecture lead and was also one of the original members of the first Red Hat team at Accenture in 2016. Jan is a senior technology architect within the MTA program and was lead technology architect on the Accenture Cloud Innovation Center in Zurich. He currently lives in Toulouse, France with his wife and 2 small boys.',
    name: 'Jan Myklebust',
    photo:
      'https://www.openslava.sk/images/2022/jan_myklebust_48ac7fdc-96b4-474d-8dce-0d9813b22444.jpg',
    shortDesc: 'Jan is a Senior Solutions A...',
    order: 0,
    talks: ['a361eca5-11fa-4c8f-b388-5ee14d8e0055', 'de3b866e-8c7c-4489-a1df-9024bc399f14']
  },
  {
    id: 'aac7c34e-9784-4b9e-9e56-8a99c3c122e3',
    company: 'launchlabs',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Viktor has a unique combination of IT knowledge, great interpersonal, analytical and organizational skills, with creativity and passion for conquering new horizons. Strong management skills with ability to analyze and improve processes, experienced in public and corporate world, driving digital transformation and digitalization, emerging technologies in EU governance and international collaboration.',
    name: 'Viktor Vartík ',
    photo:
      'https://www.openslava.sk/images/2022/viktor_vartík _aac7c34e-9784-4b9e-9e56-8a99c3c122e3.jpg',
    shortDesc: 'Viktor has a unique combina...',
    order: 0,
    talks: ['81deeef0-b68a-4ed5-bfc3-d95a31be0ae1']
  },
  {
    id: 'db811648-8dd5-4b81-81bc-14a2ee5fea4b',
    company: 'Accenture',
    country: 'Germany',
    featured: true,
    isConfirmed: true,
    longDesc:
      "I'm a global managing director and thought leader in our Technology Innovation (TI) group. Based in the Isar Valley technology hotspot in Munich I'm responsible for our TI business in Austria, Switzerland and Germany. In Europe I'm driving the incubation of the next generation businesses for Accenture triggered by disruptive technology changes in the areas of blockchain and distributed ledgers, extended reality and the metaverse, quantum computing and crypto agility, and new applications of robotics beyond the traditional industrial manufacturing. Globally I'm caring for building the next generation of capabilities and leaders in these fields. As Client Innovation Director at one of our largest industrial clients I bring the full breadth of innovation that Accenture has to offer and apply it to create value for concrete use cases. Follow me and my team looking for #TechInnoValue.",
    name: 'Matthias Ziegler',
    photo:
      'https://www.openslava.sk/images/2022/matthias_ziegler_db811648-8dd5-4b81-81bc-14a2ee5fea4b.jpg',
    shortDesc: "I'm a global managing direc...",
    order: 0,
    talks: ['e10b1f11-0b63-4e3e-baa5-15aed008ce04']
  },
  {
    id: '5306358d-11ef-4b69-b8a4-b7b45b4193ae',
    company: 'Erste Digital',
    country: 'Austria',
    featured: false,
    isConfirmed: true,
    longDesc:
      'Software developer and automation wizard with over decade of infrastructure and engineering experience. Passionate best practices advocate and relentless learner. ',
    name: 'Pavel Kestefran',
    photo:
      'https://www.openslava.sk/images/2022/pavel_kestefran_5306358d-11ef-4b69-b8a4-b7b45b4193ae.jpg',
    shortDesc: 'Software developer and auto...',
    order: 0,
    talks: ['60bcd045-527c-40fc-86b5-1fff96f1542e']
  },
  {
    id: 'ee3c5804-661c-4181-ab1b-3e405e96f2b7',
    company: 'Accenture',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'Technical architect',
    name: 'Otto Klima',
    photo:
      'https://www.openslava.sk/images/2022/otto_klima_ee3c5804-661c-4181-ab1b-3e405e96f2b7.jpg',
    shortDesc: 'Technical architect',
    order: 0,
    talks: ['e5d4990b-1286-46ba-9215-b877c1700eda']
  },
  {
    id: '8003b162-77b2-423c-a815-1fee5997c8b7',
    company: 'Couchbase',
    country: 'Germany',
    featured: false,
    isConfirmed: true,
    longDesc:
      'More than 20 years ago, Alexander Schlüter started his career as a developer, consultant and trainer in software projects based on relational databases, OLAP applications and reporting tools. Later, he focused on customer service solutions, customer engagement technologies and the analysis of large amounts of data on customer and user behaviour as well as on strategic and operational quality assurance, especially in the healthcare technology, telco and automotive industries. Now he is active in the Big Data environment and advises companies on how to implement different, complex requirements for their data management, as well as how to modernize existing solutions in order to optimize costs and tap new revenue potential.',
    name: 'Alexander Schlüter',
    photo:
      'https://www.openslava.sk/images/2022/alexander_schlüter_8003b162-77b2-423c-a815-1fee5997c8b7.jpg',
    shortDesc: 'More than 20 years ago, Ale...',
    order: 0,
    talks: ['d2ec41e1-9718-4db6-89bd-928d6a9ff7eb']
  },
  {
    id: '9eb492c1-2d92-4755-81d0-22b33e231b0d',
    company: 'Red Hat',
    country: 'Red Hat EMEA',
    featured: false,
    isConfirmed: true,
    longDesc:
      'I am a Senior Solution Architect specialized in High Performance Computing Systems & Cloud Infrastructure. I focus on conceptualizing and delivering complex technical solutions, whilst making sure to provide business value. My main expertise is on Enterprise Kubernetes, Openshift, Cloud Storage, Virtualization, and Public & Private Cloud. More recently I have been deeply involved in optimizing Cloud Infrastructure for AI/ML platforms, particularly enabling customers to realize large & high performance Open Data Hub and Kubeflow environments.',
    name: 'Rafael Cardona',
    photo:
      'https://www.openslava.sk/images/2022/rafael_cardona_9eb492c1-2d92-4755-81d0-22b33e231b0d.jpg',
    shortDesc: 'I am a Senior Solution Arch...',
    order: 0,
    talks: ['90ea097a-1f30-4c77-8f09-f2efe7b5fc63', 'ceb27fc1-d67c-4c69-a6fb-5f803fdbc214']
  },
  {
    id: 'c672588e-7f74-4583-a2d0-e0da41ac410e',
    company: 'Accenture',
    country: 'Slovakia',
    featured: false,
    isConfirmed: true,
    longDesc: 'Technical architect',
    name: 'Robert Parak',
    photo:
      'https://www.openslava.sk/images/2022/robert_parak_c672588e-7f74-4583-a2d0-e0da41ac410e.jpg',
    shortDesc: 'Technical architect',
    order: 0,
    talks: ['e5d4990b-1286-46ba-9215-b877c1700eda']
  },
  {
    id: '80e579f4-f987-4841-95bc-0b8dd5dbb372',
    company: 'Accenture',
    country: 'Austria',
    featured: true,
    isConfirmed: true,
    longDesc:
      "After 15 years in the business Dominik still enjoys new tech and can't resist playing with most new databases or new programming languages/paradigms; however the mindset has shifted from general curiosity to more strategic view of how this might be useful and develop onwards.",
    name: 'Dominik Wagenknecht',
    photo:
      'https://www.openslava.sk/images/2022/dominik_wagenknecht_80e579f4-f987-4841-95bc-0b8dd5dbb372.jpg',
    shortDesc: 'After 15 years in the busin...',
    order: 965,
    talks: ['1b066f53-2662-4d98-b075-338c9edc9eac']
  }
];

export default speakers;
